<template>
  <div class="relative">
    <button
      type="button"
      @click="toggleAccordion"
      class="relative flex items-center w-full h-10 pr-2 text-left cursor-pointer sm:text-sm sm:leading-6 group py-1.5 pl-3 focus:outline-none text-theme-700 font-medium border-y border-cyan-base"
      :class="isOpen ? 'bg-cyan-light' : 'bg-white hover:bg-slate-100'">
      <span class="absolute inset-y-0 flex items-center pr-2 pointer-events-none">
        <Icon
          icon="carbon:chevron-down"
          class="w-4 h-4 transition duration-200 ease-in-out"
          :class="{ '-rotate-90': !isOpen }" />
      </span>
      <span class="block ml-6 truncate">{{ name }} </span>
      <span class="invisible ml-auto group-hover:visible">
        <slot name="hover-content"></slot>
      </span>
      <span class="ml-auto group-hover:hidden">
        <slot name="controls"></slot>
      </span>
    </button>
    <Transition
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div v-if="isOpen" class="h-full mt-1">
        <slot name="content" />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Icon } from '@iconify/vue';

defineProps<{
  name: string;
}>();

const isOpen = ref(false);

function toggleAccordion() {
  isOpen.value = !isOpen.value;
}
</script>
